import type {Detail, GrpcBadRequest, GrpcErrorInfo} from './types';

export const isErrorInfo = (detail: Detail): detail is GrpcErrorInfo => 'reason' in detail;
export const isDetailWithViolations = (detail: Detail): detail is GrpcBadRequest => 'field_violations' in detail;
